import { AxiosInstance } from "axios";
import { useMutation } from "react-query";
import { urls } from "../common/urls";

interface PostRetestProcedureProps {
  authAxios: AxiosInstance;
  procedure_result: string;
}

interface PostReviewProcedureProps extends PostRetestProcedureProps {
  disposition: string | undefined;
}

export interface Note {
  authAxios: AxiosInstance;
  id: string;
  owner: number | null;
  subject: string;
  text: string;
  note_type: number;
  disposition: number | null;
  labels: object | null;
  groups: object | null;
  tagged_users: object | null;
}

export const retestProcedure = async ({
  authAxios,
  procedure_result,
}: PostRetestProcedureProps): Promise<any> => {
  const { data } = await authAxios.post(urls.manageResults.retestProcedure, {
    procedure_result,
  });
  return data;
};

export const useRetestProcedure = () => {
  return useMutation(retestProcedure);
};

export const reviewProcedure = async ({
  authAxios,
  procedure_result,
  disposition,
}: PostReviewProcedureProps): Promise<any> => {
  const { data } = await authAxios.post(urls.manageResults.review, {
    procedure_result,
    disposition,
  });
  return data;
};

export const useReviewProcedure = () => {
  return useMutation(reviewProcedure);
};

export const mutateCharts = ({ curves }: any) => {
  var charts: any[] = [];
  if (curves !== undefined) {
    curves.map((curve: any) => {
      charts = [
        ...charts,
        { id: curve.id, color: curve.color, data: curve.chart },
      ];
    });
  }
  return charts;
};

export const addNoteToResult = async ({
  authAxios,
  id,
  owner,
  subject,
  text,
  note_type,
  disposition,
  labels,
  groups,
  tagged_users,
}: Note): Promise<any> => {
  const { data } = await authAxios.post(urls.procedureResults.addNote(id), {
    owner,
    subject,
    text,
    type: note_type,
    disposition,
    labels,
    groups,
    tagged_users,
  });
  return data;
};

export const useAddNoteToResult = () => {
  return useMutation(addNoteToResult);
};



export const updateFlag = async (params: any): Promise<any> => {

  const { authAxios, id,...postParams } = params;
  const { data } = await authAxios.put(urls.procedureResults.updateFlag(id), {
    ...postParams,
  });
  return data;
};

export const useUpdateFlag = () => {
  return useMutation(updateFlag);
};


export const getSelectedProcedureFlash = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;
  const { data } = await authAxios.post(urls.procedureResults.selectedProcedureFlashValues, {
    ...postParams,
  });
  return data;
};

export const useSelectedProcedureFlash = () => {
  return useMutation(getSelectedProcedureFlash);
};



//for reports
export const rsdInsert = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;

  const { data } = await authAxios.patch(urls.createReportResult.update, {
    ...postParams,
  });
  return data;
};  


export const useAssignRSD = () => {
  return useMutation(rsdInsert);
};


//for asset
export const assetInsert = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;

  const { data } = await authAxios.post(urls.assets.submit, {
    ...postParams,
  });
  return data;
};  


export const useAssetInsert = () => {
  return useMutation(assetInsert);
};


export const updatePriority = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;
  const { data } = await authAxios.post(urls.units.addPriority, {
    ...postParams,
  });
  return data;
};

export const usePriority = () => {
  return useMutation(updatePriority);
};

//eolDispositionUpdate
export const updateEolDisposition = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;
  const { data } = await authAxios.patch(urls.eolDispositions.update, {
    ...postParams,
  });
  return data;
};

export const useUpdateEolDisposition = () => {
  return useMutation(updateEolDisposition);
};

export const getSelectedProcedure = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;
  const { data } = await authAxios.post(urls.stepResults.testType, {
    ...postParams,
  });
  return data;
};

export const useSelectedProcedure = () => {
  return useMutation(getSelectedProcedure);
};

export const CloudImageUpload = async (params: any): Promise<any> => {
  const { authAxios, ...postParams } = params;

  const body = Array.isArray(postParams.payload)
    ? postParams.payload
    : { ...postParams };

  const { data } = await authAxios.post(urls.reportWriterAgenda.CloudFileUpload, body);
  return data;
};

export const useCloudImageUpload = () => {
  return useMutation(CloudImageUpload);
};